<template>

	<form action="" class="search-bar">
		<b-input-group>
			<b-input-group-text slot="prepend">
				<svg><use xlink:href="/img/icons/search.svg#Symbols" href="/img/icons/search.svg#Symbols"></use></svg>
			</b-input-group-text>
			<b-form-input ref="input" :placeholder="placeholder" @input="getInput" @change="getInput"></b-form-input>
			<button v-if="showReset" @click="showReset = !showReset" class="close-icon" type="reset"></button>
		</b-input-group>
    </form>

</template>

<script>

    import algoliasearch from 'algoliasearch';
    import autocomplete from 'autocomplete.js';
    import placesAutocompleteDataset from 'places.js/autocompleteDataset.js';
    import Geolocation from '../modules/Geolocation'

	import Lang from 'lang.js';
	import translations from '../vue-translations'

    export default {

		props: [
		    'algoliaId',
            'algoliaKey',
		    'trad',
            'indice',
            'allLink',
            'itemLink',
            'cityLink',
			'lang',
        ],

        data() {
            return {

				trans: null,
				placeholder: this.trad.placeholder,
                client: null,
                index: null,
                autocompleteInstance: null,

                lat: null,
                lng: null,
				showReset: false,
            }
        },

        computed: {
            prettyResults() {
                return this.results.map((result) => {
                    result.name = result._highlightResult.name.value
                    return result
                })
            }
        },

        mounted() {
			// Localization
			const lang = new Lang()
			this.trans = lang
			this.trans.setLocale(this.lang)
			this.trans.setMessages(translations)

            this.initSearch();
            this.listenEvents();

            Geolocation.localize().then((position) => {
                this.lat = position.lat
                this.lng = position.lng
            })
        },

        methods: {

			getInput(value) {
				if(value != '' && !this.showReset) {
					this.showReset = true
				} else if(value === '' && this.showReset) {
					this.showReset = false
				}
			},

            initSearch() {

                this.client = algoliasearch(this.algoliaId, this.algoliaKey)
                this.index = this.client.initIndex(this.indice)

                // Init Auto Complete
                this.autocompleteInstance = autocomplete(this.$refs.input.$el, {
                    hint: false,
                    debug: false,
                    autoselect: true,
                    openOnFocus: true,
                    clearOnSelected: true,
                    cssClasses: {prefix: 'ad-example'},
                }, [
                    this.getPlacesDataset(),
                    this.getCitiesDataset(),
                ]);
            },

            getPlacesDataset() {
				const trans = this.trans
                return {
					source: this.searchPlaces,
                    displayKey: 'name',
                    name: 'first',
                    templates: {
                        header: `
                            <div class="ad-example-header">
                                Restaurants
                                <a href="${this.allLink}">${this.trad.show_all}</a>
                            </div>
                        `,
                        suggestion: function(suggestion) {

                            let kitchens = suggestion._highlightResult.kitchens.map((kitchen) => {
								kitchen.value = kitchen.value.replace('<em>', '');
								kitchen.value = kitchen.value.replace('</em>', '');
								return trans.get('resto-details.'+kitchen.value)

								// return kitchen.value
                            }).join(', ')

                            let distance = suggestion._rankingInfo.matchedGeoLocation.distance / 1000

                            return `
                                <div class="thumb" style="background-image: url(${suggestion.thumb});"></div>
                                <div class="content">
                                	<span class="title">${suggestion._highlightResult.name.value}</span>
                                	<span class="terms">${kitchens}</span>
                                	<span class="location">
										${suggestion._highlightResult.city ? suggestion._highlightResult.city.value + ' - ' : ''}
										${distance.toFixed(1)}km
									</span>
                                </div>
                            `
                        }
                    }
                };
            },

            searchPlaces(query, callback) {

                let queryParams = {
                    query,
                    hitsPerPage: 5,
                    getRankingInfo: true,
                    restrictSearchableAttributes: ['name', 'city', 'kitchens']
                }

                if(this.lat && this.lng) {
                    queryParams['aroundLatLngViaIP'] = false
                    queryParams['aroundLatLng'] = this.lat + ',' + this.lng
                } else {
                    queryParams['aroundLatLngViaIP'] = true
                }

                this.index.search(queryParams).then(function(answer) {
                    callback(answer.hits);
                }, function() {
                    callback([]);
                });
            },

            getCitiesDataset() {

                return placesAutocompleteDataset({
                    algoliasearch: algoliasearch,
                    appId: 'plS0GZWM71UF',
                    apiKey: '222b976c7075a26dd4436e0367baaf36',
                    type: 'city',
                    aroundLatLngViaIP: false,
                    countries: ['BE'],
                    language: document.getElementsByTagName('html')[0].getAttribute('lang'),
                    templates: {
                        header: '<div class="ad-example-header">'+this.trad.city+'</div>',
                        value: (suggestion) => suggestion.name,
                        suggestion: function(suggestion) {
                            return `
                                <div class="thumb" style="background-image: url(/img/icons/search/city.png);"></div>
                                <div class="content">
                                	<span class="title"> ${suggestion.name}</span>
                                	<span class="location">
										${suggestion.postcode ? `<small>${suggestion.postcode}</small>` : ''}
									</span>
                                </div>
                            `
                        }
                    },
                    hitsPerPage: 2
                });
            },

            listenEvents() {

                // LISTEN EVENTS
                let autocompleteChangeEvents = ['selected', 'autocompleted'];
                autocompleteChangeEvents.forEach((eventName) => {
                    this.autocompleteInstance.on('autocomplete:'+ eventName, (event, suggestion, datasetName) => {
                        if(datasetName === 'first')
                            window.location = this.itemLink.replace("%slug%", suggestion.slug)
                        if(datasetName === 'places')
                            window.location = this.cityLink
								.replace("%25lat%25", suggestion.latlng.lat)
								.replace("%25lng%25", suggestion.latlng.lng)
								.toLowerCase()
                    });
                });

            }
        }

    }
</script>

<style>

    .ad-example-dropdown-menu {
        color: black;
        background-color: #fff;
        padding: .5em;
        box-shadow: 1px 1px 32px -10px rgba(167, 164, 164, 0.5);
    }
    #sticky-search .ad-example-dropdown-menu {
		width: calc(100% + 34px);
		left: -34px !important;
		margin-top: 0;
        border-bottom: 1px solid #A7A4A4;
        border-top: none;
        border-radius: 0;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
    }
	.desktop-search-nav .ad-example-dropdown-menu {
		min-width: 400px;
		left: -36px !important;
		margin-top: 3px;
        border: 1px solid #A7A4A4;
        border-top: none;
        border-radius: 5px;
		top: 0;
		left: 0;
		right: 0 !important;
    }

    .ad-example-header {
        font-size: 14px;
        border-bottom: 1px solid #bcbcbc;
    }

    .ad-example-header a {
        float: right;
        color: #E33042;
        font-weight: normal;
        font-size: 12px;
    }

	/*SUGGESTION LINE*/

    .ad-example-dropdown-menu .ad-example-suggestion {
        display: flex;
        position: relative;
        cursor: pointer;
        padding: 0px 0px;
        margin: 4px 0;
        transition: all .5s;
    }
    .ad-example-dropdown-menu .ad-example-suggestion.ad-example-cursor {
        background-color: #f7f7f7;
    }
    /*.ad-example-dropdown-menu .ad-example-suggestion.ad-example-cursor:after{*/
        /*display: block;*/
        /*content: '';*/
        /*position: absolute;*/
        /*top: 0;*/
        /*right: 0;*/
        /*height: 100%;*/
        /*width: 2px;*/
        /*background-color: #E33042;*/
    /*}*/
	.ad-example-dropdown-menu .ad-example-suggestion .thumb {
		width: 60px;
		min-width: 60px;
		height: 60px;
		margin-right: 10px;
        background-color: #f7f7f7;
        background-size: cover;
        background-position: center center;
	}
    .ad-example-dropdown-menu .ad-example-suggestion .content {
        width: auto !important;
        margin-right: 10px;
        background-size: cover;
        background-position: center center;
        padding: 4px 0;
    }

	.ad-example-dropdown-menu .ad-example-suggestion .title {
		display: block;
		font-size: 14px;
		color: #E33042;
        line-height: 14px;
        margin-bottom: 1px;
	}

	.ad-example-dropdown-menu .ad-example-suggestion .terms {
        width: auto !important;
		display: block;
		font-size: 12px;
		opacity: .5;
        margin-bottom: 12px;
        line-height: 12px;
	}

	.ad-example-dropdown-menu .ad-example-suggestion .location {
		display: block;
		font-size: 12px;
        line-height: 12px;
	}

    .ad-example-dropdown-menu .ad-example-suggestion em {
        font-weight: bold;
        font-style: normal;
    }

    .ap-footer {
        display: none;
    }

	@media (max-width: 1024px) {
		.desktop-search-nav .ad-example-dropdown-menu {
			min-width: 350px;
	    }
	}

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PlacesAutocomplete.vue